exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbody[data-v-49bfe882]{width:20px;border-radius:10px;height:480px;position:absolute;top:50%;right:0;margin-top:-230px;z-index:95;box-sizing:border-box;padding:10px 0}.navbody .navItem[data-v-49bfe882]{font-size:16px;color:#777}.navbody .flagItem[data-v-49bfe882],.navbody .navItem[data-v-49bfe882]{width:20px;height:20px;text-align:center;line-height:20px;user-select:none}.navbody .flagItem[data-v-49bfe882]{font-size:14px;color:#fff;background:#4395ff;border-radius:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49bfe882","scoped":true,"hasInlineConfig":false}!./node_modules/_stylus-loader@3.0.2@stylus-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/packages/components/NavList.vue
// module id = 41
// module chunks = 0